// extracted by mini-css-extract-plugin
export var childrenContainer = "_99-0";
export var virtualScrollArea = "_99-1";